
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AuthenticationContext } from "vue-adal";
import axios from "axios";
import { default as parse } from "csv-parse/lib/es5/sync";

interface DictObj {
  id?: string;
  Name?: string;
  Culture?: string;
  SpellingDictionaryBLOB?: any;
  SpellingDictionarySizeText?: string;
  CanDeselect?: boolean;
  DefaultSelected?: boolean;
}

@Component({
  components: {},
})
export default class SpellingDictionaries extends Vue {
  private static async cvtBLOB2Base64_(b) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (reader.result == null) {
          reject();
          return;
        }
        if (typeof reader.result !== "string") {
          reject();
          return;
        }
        const i = reader.result.indexOf(",");
        resolve(reader.result.substr(i + 1));
      };
      reader.readAsDataURL(b);
    });
  }

  public isBusy = false;
  public selectedVersion = null; // dont understand why getting rid of this causes crash
  public addingNewVersion = false;
  public selected = [];
  public selectedDictionary: DictObj = {
    SpellingDictionaryBLOB: null,
    SpellingDictionarySizeText: "",
    Name: "",
    Culture: "",
    CanDeselect: undefined,
    DefaultSelected: undefined,
  };
  public selectedUnchangedVersion: any = {};
  public filter: string = "";
  public fields = [
    {
      key: "Name",
      label: "Name",
      sortable: true,
    },
    {
      key: "Culture",
      label: "Culture",
      sortable: true,
    },
  ];
  public totalRows = 1;
  public versionsAvailable: DictObj[] = [];
  public isSaveButtonEnabled = true;

  public mounted() {
    this.loadVersions();
    document
      .querySelectorAll(".tableFixHead")
      .forEach((el) => el.addEventListener("scroll", this.tableFixHead));
  }

  public tableFixHead(e) {
    const el = e.target;
    const sT = el.scrollTop;
    el.querySelectorAll("thead th").forEach(
      (th) => (th.style.transform = `translateY(${sT}px)`)
    );
  }

  // public async isSaveButtonEnabled() {
  //     let l = this.selectedUnchangedVersion;
  //     let r = this.selectedDictionary;
  //     const result = JSON.stringify(l)!=JSON.stringify(r);
  //     return result;
  // }

  public startCreateNewVersion() {
    this.addingNewVersion = true;
    this.selectedDictionary.id = "";
    this.selectedDictionary.Name = "";
    this.selectedDictionary.Culture = "";
    this.selectedDictionary.SpellingDictionarySizeText = "none";
    this.selectedDictionary.SpellingDictionaryBLOB = null;
    Object.assign(this.selectedUnchangedVersion, this.selectedDictionary);
    (this.$refs.versionTable as any).clearSelected();
    return true;
  }

  public loadVersions() {
    this.isBusy = true;
    this.addingNewVersion = false;
    this.cancel();
    axios
      .get(
        "/api/v4/Content/Data?filter-Category=SlideFox-Spelling-Dictionary&exclude=Value"
      )
      .then(
        (response) => {
          this.processVersionsAvailable_(response.data);
          this.isBusy = false;
        },
        (error) => {}
      );
  }

  public displayEditBox() {
    return this.addingNewVersion || this.selected.length !== 0;
  }

  public async saveVersionChanges() {
    if (!this.selectedDictionary.SpellingDictionaryBLOB) {
      this.makeToast(
        `invalid dictionary to upload (be sure it ends with .xlsx)`,
        "danger"
      );
      return;
    }
    if (!this.selectedDictionary.Name) {
      this.makeToast(`invalid dictionary name`, "danger");
      return;
    }

    // const reader = new FileReader();
    // reader.onload = e => {
    //     this.setSelectedSpellingDictionaryBLOB_(reader.result);
    // };
    // reader.readAsBinaryString(this.selectedDictionary.SpellingDictionaryBLOB);
    // this.setSelectedSpellingDictionaryBLOB_(reader.result);

    const spellDict: any = {
      Contents: await SpellingDictionaries.cvtBLOB2Base64_(
        this.selectedDictionary.SpellingDictionaryBLOB
      ),
      CanDeselect: this.selectedDictionary.CanDeselect,
      DefaultSelected: this.selectedDictionary.DefaultSelected,
    };
    const spellDictContentItem: any = {
      Name: this.selectedDictionary.Name,
      Culture: this.selectedDictionary.Culture,
      Category: "SlideFox-Spelling-Dictionary",
      ContentType: "application/json",
      Value: btoa(JSON.stringify(spellDict)),
      AuxiliaryAttributes: {
        CanDeselect:
          this.selectedDictionary.CanDeselect == null
            ? null
            : this.selectedDictionary.CanDeselect.toString(),
        DefaultSelected:
          this.selectedDictionary.DefaultSelected == null
            ? null
            : this.selectedDictionary.DefaultSelected.toString(),
      },
    };
    if (this.selectedDictionary.id) {
      spellDictContentItem.ID = this.selectedDictionary.id;
    }
    this.isBusy = true;
    await axios.post("/api/v4/Content/Data", spellDictContentItem).then(
      (response) => {
        this.isBusy = false;
        this.makeToast("SpellingDictionary version saved!");
        this.loadVersions();
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          `SpellingDictionary version could not be saved, please try again later. ${error.message}`,
          "danger"
        );
      }
    );
  }

  public isIdValid(user?) {
    // @todo improve so regexp if valid version#
    let u = this.selectedDictionary;
    if (user) {
      u = user;
    }
    if (!u.id || u.id.trim() === "") {
      return false;
    }
    return true;
  }

  public deleteVersion(id?) {
    this.isBusy = true;
    let v = this.selectedDictionary.id;
    if (id) {
      v = id;
    }
    axios.delete(`/api/v4/Content/Data/${v}`).then(
      (response) => {
        this.isBusy = false;
        this.makeToast("Dictionary Deleted!");
        this.loadVersions();
      },
      (error) => {
        this.isBusy = false;
        this.makeToast(
          "Dictionary Could not be deleted, please try again later.",
          "danger"
        );
      }
    );
  }

  public makeToast(msg, vrant = "success") {
    this.$bvToast.toast(`${msg}`, {
      title: "Operation Completed",
      autoHideDelay: 3000,
      variant: vrant,
      appendToast: false,
    });
  }

  // Take the already downloaded SpellingDictionary and make it appear to the user as a download
  public fetchSpellingDictionary() {
    const url = window.URL.createObjectURL(
      this.selectedDictionary.SpellingDictionaryBLOB
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `ERS Dictionary ${this.selectedDictionary.Name}-${this.selectedDictionary.Culture}.xlsx`
    );
    document.body.appendChild(link);
    link.click();
  }

  public cancel() {
    this.selectedDictionary.id = "";
    this.selectedDictionary.Name = "";
    this.selectedDictionary.Culture = "";
    this.selected = [];
  }

  // Take the file specified by the user and associate it with the current SpellingDictionary BLOB.
  // Not TRUELY uploaded at this point - just prepared to upload when the user hits save.
  public setSpellingDictionaryFromFileUpload(ev) {
    const file = ev.target.files[0];
    this.setSelectedSpellingDictionaryBLOB_(file);
  }

  public rowSelected(items) {
    if (items.length > 0) {
      const u = items[0];
      /*
       * Seems simpler to do:
       *      this.selectedDictionary = u; // but that breaks observer pattern.
       *                                   // Not sure what cleanest solution is, but for now assign each field
       */
      this.selectedDictionary.id = u.id;
      this.selectedDictionary.Name = u.Name;
      this.selectedDictionary.Culture = u.Culture;
      this.selectedDictionary.SpellingDictionaryBLOB = u.SpellingDictionaryBLOB;
      this.selectedDictionary.CanDeselect = u.CanDeselect;
      this.selectedDictionary.DefaultSelected = u.DefaultSelected;
      this.setSelectedSpellingDictionaryBLOB_(null, "checking...");
      this.addingNewVersion = false;
      Object.assign(this.selectedUnchangedVersion, this.selectedDictionary);
      axios({
        url: `/api/v4/Content/Data/${this.selectedDictionary.id}?return=value`,
        method: "GET",
      }).then(
        (response) => {
          this.setSelectedSpellingDictionaryBLOB_(
            this.b64toBlob_(response.data.Contents)
          );
          Object.assign(this.selectedUnchangedVersion, this.selectedDictionary);
        },
        (error) => {
          this.selectedDictionary.SpellingDictionarySizeText =
            "no spelling dictionary found";
          this.makeToast("error retrieving spelling dictionary", "danger");
        }
      );
    }
    this.selected = items;
  }

  private b64toBlob_(base64Data, contentType = "") {
    contentType = contentType || "";
    const sliceSize = 1024;
    const byteCharacters = atob(base64Data);
    const bytesLength = byteCharacters.length;
    const slicesCount = Math.ceil(bytesLength / sliceSize);
    const byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      const begin = sliceIndex * sliceSize;
      const end = Math.min(begin + sliceSize, bytesLength);
      const bytes = new Array(end - begin);
      for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  private setSelectedSpellingDictionaryBLOB_(b, msg?: string) {
    if (b != null && !(b instanceof Blob)) {
      throw new Error("oops"); // assert failure()
    }
    this.selectedDictionary.SpellingDictionaryBLOB = b;
    if (!msg) {
      if (b == null) {
        msg = "none";
      } else {
        msg = `${(b.size / (1024 * 1024)).toFixed(3)} MB`;
      }
    }
    this.selectedDictionary.SpellingDictionarySizeText = msg;
  }

  private ciStringEquals_(l, r) {
    if (typeof l !== "string") {
      return false;
    }
    if (typeof r !== "string") {
      return false;
    }
    return l.toLowerCase() === r.toLowerCase();
  }

  private processVersionsAvailable_(d) {
    this.versionsAvailable.splice(0, this.versionsAvailable.length);
    const keys: any = Object.keys(d);
    const vals: any = Object.values(d);
    for (const k of keys) {
      const v = d[k];
      v.id = d[k].ID;
      v.Name = d[k].Name;
      v.Culture = d[k].Culture;
      v.CanDeselect = this.ciStringEquals_(
        d[k].AuxiliaryAttributes.CanDeselect,
        "True"
      );
      v.DefaultSelected = this.ciStringEquals_(
        d[k].AuxiliaryAttributes.DefaultSelected,
        "True"
      );
      this.versionsAvailable.push(v);
    }
    this.totalRows = this.versionsAvailable.length;
  }
}
